import React, { useState } from 'react';
import { useStringsContext } from '../../../contexts/strings';
import ArticleList from './article-list';
import VariablesList from './variables-list';
import ScenePage from '../../common/scene/scene-page';

enum TABS {
  ARTICLES,
  VARIABLES,
}

export default function FAQ() {
  const [selectedTab, setSelectedTab] = useState(TABS.ARTICLES);
  const { strings } = useStringsContext();

  return (
    <ScenePage
      title={strings.appBar.faq}
      breadCrumps={[strings.appBar.superAdmin]}
      tabs={[strings.faq.articles, strings.faq.variables]}
      selectedTab={selectedTab}
      onSelectedTab={setSelectedTab}
    >
      {selectedTab === TABS.ARTICLES && <ArticleList />}
      {selectedTab === TABS.VARIABLES && <VariablesList />}
    </ScenePage>
  );
}
